<template>
  <div>
    <!--container-->
    <v-container>
      <!--tob bar-->
      <bar />
      <!--tob bar end-->

      <!--template-->
      <template>
        <!--card -->

        <!--Filter Box-->
        <CustomerBasedEquipmentSearch />
        <!--Filter Box-->

        <v-card class="mx-auto my-12" outlined>
          <v-card-title class="text-h5">
            CUSTOMER BASED EQUIPMENT REPORT
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">EQUIPMENT</th>
                    <th class="text-left">QTY</th>
                    <th class="text-left">SUPPLIER</th>
                    <th class="text-left">MANUFACTURE</th>
                    <th class="text-left">MODEL</th>
                    <th class="text-left">YEAR OF PURCHASE</th>
                    <th class="text-left">CONDITIN OF EQUIPMENT</th>
                    <th class="text-left">REMARKS</th>
                    <th class="text-left">WORKSHOP NAME</th>
                    <th class="text-left">ADDRESS 1</th>
                    <th class="text-left">STATE</th>
                    <th class="text-left">CITY</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="enquiry in enquiryData.customerReport"
                    :key="enquiry.sno"
                  >
                    <td>{{ enquiry.productName }}</td>
                    <td>{{ enquiry.qty }}</td>
                    <td>{{ enquiry.supplier }}</td>
                    <td>{{ enquiry.manufactur }}</td>
                    <td>{{ enquiry.model }}</td>
                    <td>{{ enquiry.purchase_year }}</td>
                    <td>{{ enquiry.condition_of_equipment }}</td>
                    <td>{{ enquiry.remarks }}</td>
                    <td>{{ enquiry.workshopName }}</td>
                    <td>{{ enquiry.address1 }}</td>
                    <td>{{ enquiry.state }}</td>
                    <td>{{ enquiry.city }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </template>
      <!--template end-->
    </v-container>
    <!--container end-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CustomerReport",
  data: () => ({
    search: ""
  }),
  computed: {
    ...mapGetters(["getCustomerreportdata"]),
    enquiryData: function() {
      // console.log(this.getCustomerreportdata);
      return this.getCustomerreportdata;
    }
  },
  watch: {},
  created() {}
};
</script>
